import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';
import Dashboard from '../../views/Dashboard/';
import Charts from '../../views/Charts/';
import Widgets from '../../views/Widgets/';
import { getUserInformation, ajaxWrapperGet } from '../../utils/deviceAPI';
import AuthService from '../../components/AuthService';
// Components
import Buttons from '../../views/Components/Buttons/';
import Cards from '../../views/Components/Cards/';
import LoadingIndicator from '../../utils/LoadingIndicator'
// import Forms from '../../views/Components/Forms/';
import Modals from '../../views/Components/Modals/';
import SocialButtons from '../../views/Components/SocialButtons/';
import Switches from '../../views/Components/Switches/';
import Tables from '../../views/Components/Tables/';
import Tabs from '../../views/Components/Tabs/';

// Icons
import FontAwesome from '../../views/Icons/FontAwesome/';
import SimpleLineIcons from '../../views/Icons/SimpleLineIcons/';

// Forms
import BasicForms from '../../views/Forms/BasicForms/';
import AdvancedForms from '../../views/Forms/AdvancedForms';

// Editors
import TextEditors from '../../views/Editors/TextEditors';
import CodeEditors from '../../views/Editors/CodeEditors';

// Plugins
import LoadingButtons from '../../views/Plugins/LoadingButtons/';
import Spinners from '../../views/Plugins/Spinners/';


// UI Kits
import Invoice from '../../views/UI-Kits/Invoicing/';
import Inbox from '../../views/UI-Kits/Email/Inbox/';
import Message from '../../views/UI-Kits/Email/Message/';
import Compose from '../../views/UI-Kits/Email/Compose/';

//sites

import DeviceInformation from '../../views/site/information/DeviceInformation';
import Overview from '../../views/site/Overview/Overview';
import Alarms from '../../views/site/Alarms/Alarms';
import AnnunciatorSystem from '../../views/site/Annunciator/System';
import Control from '../../views/site/Control/Control';
import VerifyPhone from '../../views/Userconfig/VerifyPhone';
import Configuration from '../../views/site/Configuration/Configuration';
import Account from '../../components/Account/Account';
import Developer from '../../views/site/Developer/Developer';

//admin

import Users from '../../views/Admin/Users/Users';
import Siteinvitations from '../../views/Invitations/Siteinvitations';
import Accountinvitations from '../../views/Invitations/Accountinvitations';
import Siteusers from '../../views/site/Users/Users';
import Help from '../../views/Help/Help'

const renderMergedProps = (component, ...rest) => {
    const finalProps = Object.assign({}, ...rest);
    return (
        React.createElement(component, finalProps)
    );
};

const PropsRoute = ({ component, ...rest }) => {
    return (
        <Route {...rest} render={routeProps => {
            return renderMergedProps(component, routeProps, rest);
        }}/>
    );
};


class Full extends Component {

    constructor(props) {
        super(props);
        this.state = { data: [
            {

                initializer: 0
            },
            {
                initializer: 0
            }
        ],
            loading: true,
            notifications: {
                notifications: 0
            },
            uiData: [
                {
                    alarms:[]
                }
            ],
            devicestatus: 0,
            siteAlarmPresent: false

        };
        this.Auth = new AuthService();
    }
    componentDidMount() {
        getUserInformation().then((data) => {
            this.setState({
                data,
                loading: false

            });

            this.tick();
            this.timerID = setInterval(
                () => this.tick(),
                20000
            );

        }).catch((error) => {
            localStorage.removeItem('id_token');
            this.props.history.replace('/500');
        });



    }
    tick() {
        ajaxWrapperGet('/api/user/dashboardData').then((uiData) => {
            //console.log(uiData);
            this.setState({
                uiData
            });

        });
    }
    //custom functions

    pageSwitch() {
        if (!this.state.loading) {
            this.Auth.refreshToken();
        }

    }




    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        return (
            <div className="app">
                <Header {...this.props}/>
                <div className="app-body">
                    <Sidebar {...this.props} menuitems={this.state.data} sitealarmpresent={this.state.uiData.alarms}/>
                    <main className="main">
                        <Breadcrumb />
                        <Container fluid>
                            <Switch onEnter={this.pageSwitch()}>
                                <PropsRoute path="/dashboard" name="Dashboard" component={Dashboard} uidata={this.state.uiData}/>
                                <PropsRoute path="/site/overview/:dev/:site" name="Overview" component={Overview} devicestatus={this.state.uiData.alarms}/>
                                <PropsRoute path="/site/alarms/:dev/:site" name="Alarms" component={Alarms} devicestatus={this.state.uiData.alarms}/>
                                <PropsRoute path="/site/annunciator/system" name="System Annunciator" systemtype="system" component={AnnunciatorSystem} devicestatus={this.state.devicestatus}/>
                                <PropsRoute path="/site/annunciator/generator1" name="Generator 1 Annunciator" systemtype="generator" generator={1} component={AnnunciatorSystem} devicestatus={this.state.devicestatus}/>
                                <PropsRoute path="/site/annunciator/generator2" name="Generator 1 Annunciator" systemtype="generator" generator={2} component={AnnunciatorSystem} devicestatus={this.state.devicestatus}/>
                                <PropsRoute path="/site/annunciator/utility1" name="Utility 1 Annunciator" systemtype="utility" utility={1} component={AnnunciatorSystem} devicestatus={this.state.devicestatus}/>
                                <PropsRoute path="/site/annunciator/utility2" name="Utility 2 Annunciator" systemtype="utility" utility={2} component={AnnunciatorSystem} devicestatus={this.state.devicestatus}/>
                                <PropsRoute path="/site/control/:dev/:site" name="Control" component={Control} devicestatus={this.state.uiData.alarms}/>
                                <PropsRoute path="/site/information/:dev/:site" name="Information" component={DeviceInformation} devicestatus={this.state.uiData.alarms}/>
                                <PropsRoute path="/site/users/:dev/:site" name="Users" component={Siteusers}/>
                                <Route path="/site/configuration/:dev/:site" name="Configuration" component={Configuration} />
                                <PropsRoute path="/admin/users" name="Users" component={Users} dealer={false}/>
                                <PropsRoute path="/dealer/users" name="Users" component={Users} dealer={true}/>
                                <PropsRoute path="/account" name="Account" component={Account} uidata={this.state.uiData} {...this.props}/>
                                <PropsRoute path="/invitations/site" name="Site Invitations" component={Siteinvitations} uidata={this.state.uiData}/>
                                <PropsRoute path="/invitations/account" name="Account Invitations" component={Accountinvitations} uidata={this.state.uiData}/>
                                <Route path="/site/developer/:dev/:site" name="Developer" component={Developer} />
                                <Route path="/verify" name="Verify Phone" component={VerifyPhone}/>
                                <Route path="/help" name="Help" component={Help}/>
                                <Route path="/components/buttons" name="Buttons" component={Buttons}/>
                                <Route path="/components/cards" name="Cards" component={Cards}/>
                                <Route path="/components/modals" name="Modals" component={Modals}/>
                                <Route path="/components/social-buttons" name="Social Buttons" component={SocialButtons}/>
                                <Route path="/components/switches" name="Swithces" component={Switches}/>
                                <Route path="/components/tables" name="Tables" component={Tables}/>
                                <Route path="/components/tabs" name="Tabs" component={Tabs}/>
                                <Route path="/forms/basic-forms" name="Basic Forms" component={BasicForms}/>
                                <Route path="/forms/advanced-forms" name="Advanced Forms" component={AdvancedForms}/>
                                <Route path="/editors/text-editors" name="Text Editors" component={TextEditors}/>
                                <Route path="/editors/code-editors" name="Code Editors" component={CodeEditors}/>
                                <Route path="/icons/font-awesome" name="Font Awesome" component={FontAwesome}/>
                                <Route path="/icons/simple-line-icons" name="Simple Line Icons" component={SimpleLineIcons}/>
                                <Route path="/plugins/loading-buttons" name="Loading Buttons" component={LoadingButtons}/>
                                <Route path="/plugins/spinners" name="Loading Buttons" component={Spinners}/>
                                <Route path="/widgets" name="Widgets" component={Widgets}/>
                                <Route path="/charts" name="Charts" component={Charts}/>
                                <Route path="/ui-kits/invoicing/invoice" name="Invoice" component={Invoice}/>
                                <Route path="/ui-kits/email/inbox" name="Invoice" component={Inbox}/>
                                <Route path="/ui-kits/email/message" name="Message" component={Message}/>
                                <Route path="/ui-kits/email/compose" name="Compose" component={Compose}/>
                                <Redirect from="/" to="/dashboard"/>
                            </Switch>
                        </Container>
                    </main>
                    <Aside notifications={this.state.notifications}/>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js